<template>
  <div id="app">
    <router-view />
    <div class="footer">纵缤科技提供技术支持 备案号：苏ICP备14045685</div>
  </div>
</template>

<script>
import { getApi } from '@/api'
export default {
  data () {
    return {

    }
  },
  computed: {

  },
  created () {

  },
  methods: {

  }
}
</script>

<style scoped>
  #app {
    opacity: 1 !important;
    background: white !important;
  }

  .footer {
    width: 100%;
    height: 88px;
    line-height: 88px;
    text-align: center;
    color: white;
    font-size: 22px;
    background: #282b2e;
  }
</style>



// WEBPACK FOOTER //
// src/App.vue